import { PublicQuestionnaire } from '../translations-types';

const translations: PublicQuestionnaire = {
  intro: 'Vul je gegevens in om de vragenlijst te starten.',
  nameLabel: 'Naam',
  emailLabel: 'E-mailadres',
  sendCode: 'Verstuur verificatiecode',
  codeIntro: 'We hebben een verificatiecode naar je e-mailadres gestuurd.',
  codeLabel: 'Verificatiecode',
  verify: 'Bevestigen en starten',
  nameRequired: 'Vul je naam in.',
  emailRequired: 'Vul je e-mailadres in.',
  invalidEmail: 'Vul een geldig e-mailadres in.',
  codeRequired: 'Vul de code in.',
  error: 'Er ging iets mis. Probeer het opnieuw.',
};

export default translations;
